export type StepType = "plan" | "action" | "observation" | "final";

export interface ReasoningStep {
  type: StepType;
  title: string;
  desc: string;
  tool?: string;
  done: boolean;
  error?: boolean;
  callToolId?: string;
}
